import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';
import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/AlarmModalTracking';

const initViewValues = {
  bg: 'color',
  bgColor: { background: '#ffffff' },
  radius: { background: 16, button: 0 },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: {
    title: 'Allow push notifications and get notified of sales !',
    sub_title:
      'After push permission, you will be guided through the products to add to your cart.'
  },
  fontSize: { title: 1, sub_title: 0.75 },
  fontWeight: { title: 600, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: {
    button: '알림 허용',
    sub_button: '닫기',
    never_show_button: '다시 보지 않기'
  },
  btnFontSize: { button: 1, sub_button: 0.875, never_show_button: 0.875 },
  btnFontWeight: { button: 700, sub_button: 500, never_show_button: 500 },
  btnColor: {
    button: '#ffffff',
    sub_button: '#ffffff',
    never_show_button: '#ffffff'
  },
  btnBgColorR: { button: 53, sub_button: 0, never_show_button: 0 },
  btnBgColorG: { button: 197, sub_button: 0, never_show_button: 0 },
  btnBgColorB: { button: 240, sub_button: 0, never_show_button: 0 },
  btnBgColorA: { button: 1, sub_button: 0, never_show_button: 0 },
  btnFontFamily: {
    button: 'Roboto',
    sub_button: 'Roboto',
    never_show_button: 'Roboto'
  },
  btnAgain: {
    type: 'none',
    never_show_button: "don't show"
  }
};

const AlarmModal: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );
  const templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  const btnFontSubURL = getFontURL(btnFontFamily?.sub_button);
  const btnFontNeverShowURL = getFontURL(btnFontFamily?.never_show_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const btnFontSubURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.sub_button}`;
  // const btnFontNeverShowURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.never_show_button}`;
  const alarmImageUrl = 'https://image.inappmessage.com/sample/alarm.png';

  const style = `
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }

  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }

  @font-face {
    font-family: 'btnFont';
    src: url(${btnFontURL});
    }

  @font-face {
    font-family: 'btnSubFont';
    src: url(${btnFontSubURL});
    }

  @font-face {
    font-family: 'btnNeverShowFont';
    src: url(${btnFontNeverShowURL});
    }

  .root_view {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;

                  
    position: absolute;
    top: 0;
     background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 1rem 1rem 1rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .alarm {
      text-align: center;
    }
    .alarm button {
      width: 3rem;
      height: 3rem;
      
      background-image: url(${alarmImageUrl});
      background-repeat: no-repeat;
      background-size: 3rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .title {
      height: 3.5rem;
      display: flex;
      align-items: center;
    }
    .title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'titleFont'
      };
    }
    .sub_title {
      height: 3rem;
      display: flex;
      align-items: center;
    }
    .sub_title_inner {
      width: 100%;
      height: auto;
      max-height: 2.6rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitleFont'
      };
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-weight: ${btnFontWeight?.button};
      font-size: ${btnFontSize?.button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btnFont'
      };

      color: ${btnColor?.button};
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button},
        ${btnBgColorB?.button}, ${btnBgColorA?.button});
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.never_show_button};
      font-weight: ${btnFontWeight?.never_show_button};
      font-size: ${btnFontSize?.never_show_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.never_show_button
        )
          ? btnFontFamily.never_show_button
          : 'btnNeverShowFont'
      };
      
      background-color:rgba(
      ${btnBgColorR?.never_show_button},${btnBgColorG?.never_show_button},
      ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.sub_button};
      font-weight: ${btnFontWeight?.sub_button};
      font-size: ${btnFontSize?.sub_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.sub_button
        )
          ? btnFontFamily.sub_button
          : 'btnSubFont'
      };
      
      background-color:rgba(
        ${btnBgColorR?.sub_button},${btnBgColorG?.sub_button}, 
        ${btnBgColorB?.sub_button},${btnBgColorA?.sub_button});
    }

    ${
      templateHeight < 608
        ? `
        .modal_wrapper {
          gap: 0.5rem;
        }
        .middle_text_wrapper .middle_number {
          max-width: 2rem;
          min-width: 2rem;
          max-height: 2rem;
          min-height: 2rem;
        }
        `
        : ''
    }
    ${
      templateWidth > 767
        ? `
        .center {
          width: 50%;
        }
        .modal_wrapper {
          padding: 2rem;
        }

        .title {
          height: 4.5rem;
        }
        .title_inner {
          max-height: 3.8rem;
          font-size: ${fontSize?.title + 0.5}rem;
        }
        .sub_title {
          height: 4rem;
        }
        .sub_title_inner {
          font-size: ${fontSize?.sub_title + 0.125}rem;
        }
  
        .bottom_wrapper .style01 {
          font-size: ${btnFontSize?.never_show_button + 0.25}rem;
        }
        .bottom_wrapper .style02 {
          font-size: ${btnFontSize?.sub_button + 0.25}rem;
        }
        `
        : ''
    }
  }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );

          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }

    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="center">
          <div className="modal_wrapper">
            <div className="alarm">
              <button>alarm</button>
            </div>
            <div>
              <div className="title">
                <div className="title_inner">{changeEnter(text?.title)}</div>
              </div>
              <div className="sub_title">
                <div className="sub_title_inner">
                  {changeEnter(text?.sub_title)}
                </div>
              </div>
            </div>
            <div className="btn_wrapper">
              <button className="button">{btnText?.button}</button>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">{btnText?.never_show_button}</span>
            <span className="style02">{btnText?.sub_button}</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default AlarmModal;
